export default __webpack_public_path__ + "static/media/menos_estres.9f32b6af.jpg";